import { UIText1 } from '@cian/ui-kit';
import { reloadPage } from '@cian/valuation-utils-component';
import * as React from 'react';

import * as styles from './styles.css';

export const Error: React.FC = () => {
  return (
    <div className={styles['container']} data-testid="offers_history_error">
      <UIText1 display="inline-block">Что-то пошло не так.</UIText1>{' '}
      <UIText1 display="inline-block">
        Попробуйте{' '}
        <button className={styles['pseudolink']} onClick={reloadPage}>
          перезагрузить страницу
        </button>
        , либо&nbsp;зайдите позже
      </UIText1>
    </div>
  );
};
